import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Rating= ({rating}) => {
    return (

        <div className="book__ratings">
        {new Array(Math.floor(rating)).fill(0).map((_, index) => (
          <FontAwesomeIcon icon="star" key={index} />
        ))}
        {
          // Number.isInteger(book.rating) ? '' : <FontAwesomeIcon icon="star-half-alt" />
          !Number.isInteger(rating) && (
            <FontAwesomeIcon icon="star-half-alt" />
          )
        }
      </div>

    )
}

export default Rating